import React, { useState } from "react";
import { X } from "react-feather";
import { Button, Col, Form, FormGroup, Input, Row, Spinner } from "reactstrap";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

export const TouristSearch = ({ stateUrl, stateActivateSearch }) => {
  const [keyText, setKeyText] = useState("");
  const [flag, setFlag] = useState(true);
  const [showLoading, setShowLoading] = useState(false);

  const onChange = (input) => {
    setKeyText(input);
    if (input.length > 2) {
      setFlag(false);
    } else {
      setFlag(true);
    }
  };

  const changeValueKeyTextField = (evt) => {
    const ciInputValue = evt.target.value;
    setKeyText(ciInputValue);
    if (ciInputValue.length > 2) {
      setFlag(false);
    } else {
      setFlag(true);
    }
  };

  const handleSumbit = () => {
    setShowLoading(true);
    stateUrl(`false_url?search=${keyText}`);
    setShowLoading(false);
  };

  return (
    <Row>
      <Col md="12">
        <Form className="auth-login-form mt-2" onSubmit={handleSumbit}>
          <FormGroup row>
            <Col md={10}>
              <Input
                required
                autoFocus
                valid={!flag}
                type="text"
                id="ci-field"
                name="ci_field"
                value={keyText}
                placeholder="Ingrese cualquier texto clave"
                onChange={(e) => changeValueKeyTextField(e)}
              />
            </Col>
            <Col md={2}>
              <Button
                disabled={!keyText.length || flag}
                className="p-1"
                color="success"
                size="lg"
                block
              >
                Buscar
                {showLoading ? <Spinner color="light" /> : null}
              </Button>
            </Col>
          </FormGroup>
        </Form>
      </Col>
      <Col md={12}>
        <Keyboard onChange={onChange} />
      </Col>
      <Col md={12} className="text-center mt-3 mb-3">
        <Button
          outline
          color="danger"
          size="sm"
          onClick={() => {
            stateUrl(null);
            stateActivateSearch(false);
          }}
        >
          Cancelar búsqueda <X color="red" />
        </Button>
      </Col>
    </Row>
  );
};
